
export default {
  data() {
    return {
      screenWidth: window.innerWidth
    }
  },
  computed: {
    BULMA_BREAKPOINTS() {
      return {
        MOBILE: 'mobile',
        TABLET: 'tablet',
        DESKTOP: 'desktop',
        WIDESCREEN: 'widescreen',
        FULLHD: 'fullhd',
        XXL: 'xxl'
      }
    },
    breakpoints() {
      return {
        [this.BULMA_BREAKPOINTS.MOBILE]: 0,
        [this.BULMA_BREAKPOINTS.TABLET]: 769,
        [this.BULMA_BREAKPOINTS.DESKTOP]: 1024,
        [this.BULMA_BREAKPOINTS.WIDESCREEN]: 1216,
        [this.BULMA_BREAKPOINTS.FULLHD]: 1408,
        [this.BULMA_BREAKPOINTS.XXL]: 1600
      }
    },
    isMobile() {
      return this.screenWidth < this.breakpoints[this.BULMA_BREAKPOINTS.TABLET]
    },
    isTablet() {
      return (
        this.screenWidth >= this.breakpoints[this.BULMA_BREAKPOINTS.TABLET] &&
        this.screenWidth < this.breakpoints[this.BULMA_BREAKPOINTS.DESKTOP]
      )
    },
    isDesktop() {
      return (
        this.screenWidth >= this.breakpoints[this.BULMA_BREAKPOINTS.DESKTOP] &&
        this.screenWidth < this.breakpoints[this.BULMA_BREAKPOINTS.WIDESCREEN]
      )
    },
    isWidescreen() {
      return (
        this.screenWidth >= this.breakpoints[this.BULMA_BREAKPOINTS.WIDESCREEN] &&
        this.screenWidth < this.breakpoints[this.BULMA_BREAKPOINTS.FULLHD]
      )
    },
    isFullhd() {
      return (
        this.screenWidth >= this.breakpoints[this.BULMA_BREAKPOINTS.FULLHD] &&
        this.screenWidth < this.breakpoints[this.BULMA_BREAKPOINTS.XXL]
      )
    },
    isXxl() {
      return this.screenWidth >= this.breakpoints[this.BULMA_BREAKPOINTS.XXL]
    }
  },
  methods: {
    isScreenBelow(size) {
      if (!this.breakpoints[size]) return false
      return this.screenWidth < this.breakpoints[size]
    },
    isScreenAbove(size) {
      if (!this.breakpoints[size]) return false
      return this.screenWidth >= this.breakpoints[size]
    },
    updateWidth() {
      this.screenWidth = window.innerWidth
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth)
  }
}